import "./SelectInstitutionModal.less";
import TeacherIcon from "../../../assets/images/Teacher_Icon.svg";
import StudentIcon from "../../../assets/images/student_icon.svg";

import React, { Component } from "react";
import { translate } from "react-i18next";
import $ from "jquery";
import queryString from "query-string";

const PRIMARY = "primary";
const SECONDARY = "secondary";

class SelectInstitutionModal extends Component {
	constructor(props) {
		super(props);

		this.state = {
			institution: this.props.institution || PRIMARY
		};
	}	
	
	componentDidMount() {
		if (this.props.show) {
			$("#select-profile-modal").modal("show");
		} else {
			$("#select-profile-modal").modal("hide");
		}
	}

    componentWillUnmount() {
        $("#select-profile-modal").modal("hide");
    }

	componentDidUpdate(prevProps) {
		if (this.props.show !== prevProps.show) {
			if (this.props.show) {
				$("#select-profile-modal").modal("show");
			} else {
				$("#select-profile-modal").modal("hide");
			}
		}
	}

	render() {
		const t = this.props.t;

	    const currentQuery = queryString.parse(window.location.search);
	    const returnUrl = currentQuery.returnUrl;
	    const query = queryString.stringify({ returnUrl });

		const modal = (
			<div className="modal fade" id="select-profile-modal" tabIndex="-1" role="dialog" data-backdrop="static" data-keyboard="false" aria-labelledby="exampleModalLabel" aria-hidden="true">
				<div className="modal-dialog" role="document">
					<div className="modal-content">
						<div className="modal-header">
							<h5 className="modal-title" id="exampleModalLabel">
								{t("title")}
							</h5>
						</div>
						<div className="modal-body">
							<div className="container-fluid">
								<div className="description-container">
									<p>{t("description")}</p>
									<p>{t("question")}</p>
									<div className="selectors">
										<div>
											<img src={StudentIcon} alt="" onClick={this.handleInstitutionImageClick.bind(this, PRIMARY)} />
											<label className="radio">
												<input
													name="radio"
													type="radio"
													value={PRIMARY}
													checked={this.isChecked(PRIMARY)}
													onChange={this.handleInstitutionChange.bind(this)}
												/>
												<span>{t("institution.primary")}</span>
											</label>
										</div>

										<div>
											<img src={TeacherIcon} alt="" onClick={this.handleInstitutionImageClick.bind(this, SECONDARY)} />
											<label className="radio">
												<input
													name="radio"
													type="radio"
													value={SECONDARY}
													checked={this.isChecked(SECONDARY)}
													onChange={this.handleInstitutionChange.bind(this)}
												/>
												<span>{t("institution.secondary")}</span>
											</label>
										</div>
									</div>
								</div>
							</div>
						</div>
						<div className="modal-footer">
							<a className="button-bg" href={this.state.institution === PRIMARY ? '/choice/bao?' + query : '/choice/so?' + query}>
								{t("common:enter")}
							</a>
						</div>
					</div>
				</div>
			</div>
		);

		if (this.props.show) {
			return modal;
		} else {
			return null;
		}
	}

	isChecked(institution) {
		return this.state.institution === institution;
	}

	handleInstitutionImageClick(event) {
		this.setState({
			institution: event
		});
	}

	handleInstitutionChange(event) {
		this.setState({
			institution: event.target.value
		});
	}
}

const translateSelectInstitutionModal = translate("selectInstitution")(SelectInstitutionModal);

export { translateSelectInstitutionModal as SelectInstitutionModal };



// WEBPACK FOOTER //
// ./src/components/Modals/SelectInstitutionModal/SelectInstitutionModal.js